import { ReactNode, Children, isValidElement, cloneElement } from "react";

type CallableProps<P extends object> = (componentProps: P) => P;

const renderComponent = <C extends string, P extends object = {}>(
  children: ReactNode | readonly ReactNode[],
  component?: C,
  props?: P | CallableProps<P>
) =>
  Children.map(children, (child) => {
    if (!isValidElement(child)) return;
    if ((component && (child.type as any).name === component) || (component && (child.type as any).displayName === component)) {
      const cProps = child.props;
      // console.log("Component Props", cProps);

      if (props) return cloneElement(child, (props as CallableProps<P>)(cProps));
      return child;
    }

    // if (!component && props) {
    //   return cloneElement(child, props);
    // }
    return;
  });

export default renderComponent;
